import type { Feature } from '@getstep/sdk/dist/api/generated/FeatureProto'
import { useEffect } from 'react'

import { useStores } from '../useStores'

export const useOverrideFeature = (feature: Feature, enabled: boolean) => {
    const { featureOverrideStore } = useStores()

    useEffect(() => {
        featureOverrideStore.overrideFeature(feature, enabled)
    }, [enabled, feature, featureOverrideStore])
}
